// extracted by mini-css-extract-plugin
export default {"status":"OrderStatus_status_a3HQ2"};